export const isLatAllowed = ({ floatValue }) => {
  return floatValue ? floatValue <= 90 && floatValue >= -90 : true;
};
